import { TApplicationState } from '../../types/redux';

export function getImageSourcesText({ newbuilding: { imageSources } }: TApplicationState) {
  if (!imageSources || !imageSources.length) {
    return '';
  }

  return `Источники фото: ${imageSources.join(', ')}.`;
}
